import { render } from "./ImageInput.vue?vue&type=template&id=3535e92c&scoped=true&ts=true"
import script from "./ImageInput.vue?vue&type=script&lang=ts"
export * from "./ImageInput.vue?vue&type=script&lang=ts"

import "./ImageInput.vue?vue&type=style&index=0&id=3535e92c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3535e92c"]])

export default __exports__